export default __webpack_public_path__ + "static/media/AccessGroups.b055b5ac.png";